import { Experiment, Variant } from '../../utils/constants';
import initialState from '../defaults/config';
import { RootState } from '../reducers';

export function getConfigRedirectURL({ config }: RootState) {
  // MM: currently set for specific gifts/coupons
  return config.redirectURL;
}

export function getAppVersion({ config }: RootState) {
  return config.version;
}

export function getAppTrack({ config }: RootState) {
  return config.track;
}

export function getImageCDNBaseURL({ config }: RootState) {
  return config.imageCDNBaseURL;
}

export function getExperiments({ config }: RootState) {
  return config.experiments || {};
}

export function getExperimentVariant(state: RootState, experimentName: string) {
  return getExperiments(state)[experimentName];
}

export function getIsUserLoggedIn({ config }: RootState) {
  return config.isUserLoggedIn;
}

export function getIsMobileDevice({ config }: RootState) {
  return config.isMobileDevice;
}

export function getCollections({ config }: RootState) {
  return config.collections;
}

export function getLinkedCoupon({ config }: RootState) {
  return config.coupon;
}

export function getContentCollections(state: RootState) {
  return state.config.contentCollections;
}

export function getIsSitelinksNavbarExperiment(state: RootState) {
  return getExperimentVariant(state, Experiment.SITELINKS_NAVBAR) === Variant.TREATMENT;
}

export function getIsScaleStickyExperiment(state: RootState) {
  return getExperimentVariant(state, Experiment.SCALE_STICKY_HEADER) === Variant.TREATMENT;
}

export function getPreferredChannelCount({ config }: RootState) {
  return config.preferredChannelCount || initialState.preferredChannelCount;
}

export function getPreferredBasePrice({ config }: RootState) {
  return config.preferredBasePrice || initialState.preferredBasePrice;
}

export function getStripeKey(state: RootState) {
  return state.config.stripeKey;
}

export function getUseInteractivePosters(state: RootState) {
  return getExperimentVariant(state, Experiment.POSTER_MODALS) === Variant.TREATMENT;
}

export function getEpisodesOnTopExperiment(state: RootState) {
  return getExperimentVariant(state, Experiment.SHOW_PAGE_EPISODES);
}

export function getLandingPageAddOnExperimentVariant(state: RootState) {
  return getExperimentVariant(state, Experiment.LANDING_PAGE_ADD_ON);
}

export function getIsSignUpValuePropsExperimentVariant(state: RootState) {
  return getExperimentVariant(state, Experiment.SIGNUP_VALUE_PROPS);
}

export function getIsFASTChannelExperiment(state: RootState) {
  const fastChannelExperimentVariant = getExperimentVariant(
    state,
    Experiment.FAST_CHANNEL_EXPERIMENT,
  );
  return (
    fastChannelExperimentVariant === Variant.TREATMENT_V1 ||
    fastChannelExperimentVariant === Variant.TREATMENT_V2
  );
}

export function getFASTChannelExperimentVariant(state: RootState) {
  return getExperimentVariant(state, Experiment.FAST_CHANNEL_EXPERIMENT);
}

export function getFASTUncredentialedLandingPageExperimentVariant(state: RootState) {
  return getExperimentVariant(state, Experiment.FAST_UNCREDENTIALED_LANDING_PAGE_EXPERIMENT);
}

export function getIsAutoAddOnExperiment(state: RootState) {
  return getExperimentVariant(state, Experiment.AUTO_ADD_ON) === Variant.TREATMENT;
}
